import { makeStyles } from '@material-ui/core';

const styles = makeStyles({
  titleN1: {
    fontSize: 15,
    marginRight: 12,
    fontWeight: 400,
  },
  listItem: {
    margin: 0,
  },
  nivel1: {
    marginLeft: 14,
  },
  nivel2: {
    marginLeft: 46,
  },
  nivel3: {
    marginLeft: 78,
  },
  bold: {
    fontWeight: 600,
  },
  badge: {
    backgroundColor: '#5890aa',
    color: '#ffffff',
    margin: 8,
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 12,
    borderRadius: 4,
    fontWeight: 600,
  },
});

export default styles;
